/**
 * Тонкая полоса прокрутки: переписка, поле сообщения, комментарии, календарь сессий.
 *
 * Жила шестью копиями, и каждая разошлась по-своему: скругление 9999, 4 или 2 пикселя, ползунок
 * белым на 10%, на 15% и на 8%. Одна копия ссылалась на `--chakra-colors-whiteAlpha-200`, а
 * переменные Chakra пишутся через дефис (`white-alpha-200`), и ползунок в календаре не
 * рисовался вовсе.
 *
 * Ползунок - `whiteAlpha.300`, ближайшая ступень к 15%, на которых стояло большинство копий.
 * `scrollbarColor` для Firefox берёт ту же ступень через переменную: это свойство токены темы
 * не разворачивает.
 */
export const thinScrollbar = {
  scrollbarWidth: 'thin',
  scrollbarColor: 'var(--chakra-colors-white-alpha-300) transparent',
  '&::-webkit-scrollbar': { width: '4px' },
  '&::-webkit-scrollbar-track': { background: 'transparent' },
  '&::-webkit-scrollbar-thumb': { background: 'whiteAlpha.300', borderRadius: 'full' },
} as const;
